import { UseFormReturnType } from "@mantine/form";
import { PropsWithChildren } from "react";
import { useFormAnalytics } from "@/hooks/useFormAnalytics";
import { useFormStepId } from "@/contexts/FormStepIdContext";

interface FormProps<formValues> extends PropsWithChildren {
  form: UseFormReturnType<formValues>;
  onSubmit: (values: formValues) => void;
  onContinue: () => void;
  alwaysSubmit?: boolean;
}

const Form = <formValues,>({ children, form, onSubmit, onContinue, alwaysSubmit }: FormProps<formValues>) => {
  const formStepId = useFormStepId();
  const { formError, formSubmitSuccess } = useFormAnalytics({ form, formStepId });

  const handleSubmit = (values: formValues) => {
    // Standalone forms (pages, modals) have no accordion to report their
    // submit, so the wrapper emits formSubmitSuccess itself; accordion
    // steps (formStepId set) leave it to useFormAccordion's nextStep.
    if (formStepId === undefined) {
      formSubmitSuccess();
    }
    if (!form.isDirty() && !alwaysSubmit) {
      onContinue();
      return;
    }
    onSubmit(values);
  };

  return (
    <form
      onSubmit={form.onSubmit(
        values => void handleSubmit(values),
        errors => formError(errors, form.getValues() as Record<string, unknown>)
      )}>
      {children}
    </form>
  );
};

export default Form;
